export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11599.0ad420d2.jpg";